export function generateID() {
  let result = ''
  const characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  const charactersLength = characters.length
  // Use browser-native crypto for secure random values
  const randomValues = new Uint32Array(24)
  crypto.getRandomValues(randomValues)
  for (let counter = 0; counter < 24; counter++) {
    result += characters.charAt(randomValues[counter] % charactersLength)
  }
  const splittedArray = result?.match(/(.{1,4})/g) || []
  let finalResult = ''
  for (let t = 0; t < splittedArray?.length; t++) {
    finalResult = finalResult.concat(splittedArray[t]).concat('.')
  }

  return `CM${finalResult.substring(2, finalResult.length - 1)}`

}
